import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    if (!email) return alert("❌ Please enter your email");

    setLoading(true);

    try {
      const actionCodeSettings = {
        // dynamically use current origin so it works in dev & prod
        url: `${window.location.origin}/reset-password`,
        handleCodeInApp: true,
      };

      await sendPasswordResetEmail(auth, email, actionCodeSettings);

      alert("✅ Password reset email sent! Check your inbox.");
      setEmail("");
      navigate("/login"); // optional: redirect after sending email
    } catch (error) {
      console.error(error);
      alert(`❌ Failed to send password reset email: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 p-4">
      <h2 className="text-2xl font-bold mb-4">Forgot Password</h2>
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="border p-2 rounded w-64 mb-4"
      />
      <button
        onClick={handleForgotPassword}
        className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 w-64"
        disabled={loading}
      >
        {loading ? "Sending..." : "Send Reset Email"}
      </button>
    </div>
  );
};

export default ForgotPassword;
